import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {StoreService} from '../../../../../../services/store.service';
import {AuthService} from '../../../../../../services/auth.service';
import {NotificationService} from '../../../../../../services/notification.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import {AppSettings} from '../../../../../../config/AppSettings';
import {RaceType} from '../../../../../../forms/race-type';
import {FileUpload2Component} from '../../../../../../shared/file-upload2/file-upload2.component';
import {FbUtils} from '../../../../../../class/fb-utils';
import {map} from 'rxjs/operators';

@Component({
    selector: 'app-edit-race-type',
    templateUrl: './edit-race-type.component.html',
    styleUrls: ['./edit-race-type.component.css']
})
export class EditRaceTypeComponent implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild('select_caption_tpl', {static: true}) set select_caption_tpl(value: ElementRef) {
        this._select_caption_tpl = value;
        this.cdr.markForCheck();
    }

    @ViewChild('upload_tpl', {static: true}) public upload_tpl: ElementRef;

    public loading_text = '';
    public is_loading = true;
    public fields: any[];
    public mode = 'edit';
    public edit = false;
    public rows = [];
    public count = 0;

    private subs: Array<Subscription> = [];
    private record: any;
    public id: string | number = '';
    private RaceType: RaceType;

    private _select_caption_tpl: ElementRef;

    public files = [];
    public max_file_count = 1;
    public url_file_store = AppSettings.getRealAPILink() + 'media';

    public is_admin: boolean;

    private file_upload: FileUpload2Component;

    constructor(private storeService: StoreService,
                private authService: AuthService,
                private notificationService: NotificationService,
                private route: ActivatedRoute,
                public router: Router,
                private cdr: ChangeDetectorRef,
                public dialog: MatDialog,
                public http: HttpClient) {
    }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
        this.is_admin = this.authService.isAdmin() || this.authService.hasRole(AppSettings.ifa_guild_id, AppSettings.group_page_admin)
            || this.authService.hasRole(AppSettings.ifa_guild_id, AppSettings.group_rally_admin);

        this.subs.push(this.route.params.subscribe((params: any) => {
            this.edit = this.authService.isAdmin() || this.authService.hasRole(AppSettings.ifa_guild_id, AppSettings.group_page_admin);

            if (params.id && params.id !== 'add') {
                this.mode = 'edit';
                this.id = params.id;
            } else {
                this.mode = 'add';
                // this.edit = true;
            }

            const filter = [];
            filter.push('filter[type_id][0][mode]=equals');
            filter.push('filter[type_id][0][operator]=and');
            filter.push('filter[type_id][0][value]=' + this.id);
            filter.push('first=0');
            filter.push('rows=1');

            this.RaceType = new RaceType(this.storeService, this.authService, this.mode);
            this.RaceType.init({select_caption_tpl: this._select_caption_tpl, upload_tpl: this.upload_tpl}, {},
                '?' + filter.join('&')).then((success) => {
                this.fields = this.RaceType.getEditFields();
                if (this.id && this.id !== '' && this.mode === 'edit') {
                    const rec = this.RaceType.getStore().getRecordById(this.id);
                    if (rec) {
                        this.record = rec;
                    }
                } else {
                    this.resetModel();
                }
                this.rebuildForm();
                this.is_loading = false;
            });

        }));
    }

    public rebuildForm() {
        this.fields = [];
        this.cdr.detectChanges();
        this.fields = this.RaceType.getForm(this.record.data);
        this.cdr.detectChanges();
    }

    private resetModel() {
        this.record = this.RaceType.getDefaultModel();
    }

    public saveStore(event: any) {
        if (this.mode === 'edit') {
            this.RaceType.getStore().patchRecord(this.record, '').then((res) => {
                if (res && res.success) {
                    this.notificationService.success('Data',
                        'Speichern erfolgreich.', {timeOut: 5000});
                    this.rebuildForm();
                } else {
                    this.notificationService.error('Data',
                        'Speichern fehlgeschlagen.', {timeOut: 5000});
                }
            });
        } else {
            this.RaceType.getStore().addRecord(this.record.data, '').then((res) => {
                if (res && res.success) {
                    this.notificationService.success('Data',
                        'Speichern erfolgreich.', {timeOut: 5000});
                    this.resetModel();
                    this.rebuildForm();
                } else {
                    this.notificationService.error('Data',
                        'Speichern fehlgeschlagen.', {timeOut: 5000});
                }
            });
        }
    }


    public onFileuploadInit(file_upload: FileUpload2Component) {
        this.file_upload = file_upload;
    }

    public onFileUpload($event, type, element) {
        this.record.data.file_id = $event.body.rows[0].file_id;
        if ($event.ok) {
            // this.FileStore.reloadStore('').then(records => {
            this.notificationService.success('Daten',
                'Speichern erfolgreich.', {timeOut: 5000});
            // });
        } else {
            this.notificationService.error('Daten',
                'Speichern fehlgeschlagen.', {timeOut: 5000});
            this.cdr.detectChanges();
        }
    }

    enterEditMode() {
        this.edit = true;
        this.cdr.detectChanges();
    }

    deleteFile(file_id: number) {

        return this.http.delete(FbUtils.formatUrlForApi(AppSettings.getRealAPILink() + 'media/' + file_id)).pipe(
            map((user: any) => {
            })
        ).subscribe((result) => {
            this.record.data.file_id = 0;
        });
    }

    ngOnDestroy(): void {
        this.subs.forEach(s => s.unsubscribe());
        if (this.mode === 'edit') {
            this.RaceType.getStore().revertRecord(this.record);
        }
    }
}
